import { components, type ClearIndicatorProps } from 'react-select';
import { XClose } from '@kula-ai/icons-core';

// react-select's default cross is a thin 20px glyph; kula Select draws XClose at
// 16px. Colour comes from the `clearIndicator` style, so hover still tints it.
export const SelectClearIndicator = (
  props: ClearIndicatorProps<unknown, boolean>
) => (
  <components.ClearIndicator {...props}>
    <XClose size={16} />
  </components.ClearIndicator>
);
